import React from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';

import './homePricing.scss';

const PricingHome = ({ history }) => {
  return (
    <div id="homeContainer">
      <div className="container">
        <div className="header">
          <h1 className="mt-5">Easily Compare Packages</h1>
          <div className="header underHeader mt-5 mb-5">
            <p>
              UPshow offers packages for every business size and need, allowing you to engage with your two most important
              stakeholders:
              <br />
              Your customers and employees.
            </p>
          </div>
        </div>
        <div className="grid justify-content-center">
          <Card className="col-6 mt-5">
            <div className="flex flex-column card_item_box">
              <div>
                <h2>CONNECT</h2>
                <p>Customer Experience</p>
                <p className="pUnderTitle">
                  UPshow CONNECT harnesses your TV screens to captivate customers, inspire action and build long-term loyalty.
                </p>
              </div>
              <div className="rUnderTitle">
                <div className="textmark">
                  <p>
                    <i className="pi pi-check p-mr-2" />
                    Entertain & Engage Customers
                  </p>
                </div>
                <div className="textmark">
                  <p>
                    <i className="pi pi-check p-mr-2" />
                    Enhance In-Venue Experiences
                  </p>
                </div>
                <div className="textmark">
                  <p>
                    <i className="pi pi-check p-mr-2" />
                    Drive Meaningful Actions
                  </p>
                </div>
                <div className="textmark">
                  <p>
                    <i className="pi pi-check p-mr-2" />
                    Boost Sales
                  </p>
                </div>
              </div>
              <Button
                label="See Your Options"
                className="btn-magenta"
                onClick={() => {
                  history.push('/homepricing');
                }}
              />
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

PricingHome.propTypes = {
  history: PropTypes.any.isRequired,
};

export default PricingHome;
